import React, { useState, Suspense } from "react";

// @material
import { Box, Stack } from "@mui/material";

// components
import Page from "@components/Page";
import LoadingScreen from '@components/LoadingScreen';


import AssetTable from "./AssetListViewer/AssetTable";
import DataHeader from "./Header/Title";
import DataTabs from "./Tabs";
import { SideBar } from '@pages/asset/comparison/SideBar';
import { PageTitle } from "@components/ui/styles";
// ----------------------------------------------------------------------

// const filterFunction = (asset: string[]) : string[] => {
//   return asset.map( v=> `SU-${v}`)
// }

function StockPage() {
  const [checkedAssets, setCheckedAsset] = useState<Array<Object>>([]);

  return (
    <Page title="주식 종목 탐색">
      <Stack spacing={2}>
        <PageTitle>주식 종목 탐색</PageTitle>
        <Stack direction="row" sx={{ pl: -10 }}>
          <Box sx={{ width: "100%" }}>
            <Stack spacing={2}>
              <Suspense fallback={<LoadingScreen />}>
                <AssetTable
                  onSelectAsset={(select) => {
                    const updateAsset = [select].concat(checkedAssets);
                    setCheckedAsset(updateAsset);
                  }}
                />
              </Suspense>
              <Suspense fallback={<LoadingScreen />}>
                <DataHeader />
                <DataTabs />
              </Suspense>
            </Stack>
          </Box>
        </Stack>
      </Stack>
      <SideBar
        assetType="stock"
        checkedAssets={checkedAssets.map((v) => {
          return { ...v, name: v["name"] };
        })}
        onChange={setCheckedAsset}
      />
    </Page>
  );
}

export default React.memo(StockPage);
